import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Home, LogIn } from 'lucide-react';

const FundraiserSubmissionSuccess = ({ fundraiserId, onClose }) => {
  const navigate = useNavigate();
  const [fundraiserTitle, setFundraiserTitle] = useState('');

  useEffect(() => {
    // Get fundraiser title from session storage if available
    const title = sessionStorage.getItem('lastCreatedFundraiserTitle');
    if (title) {
      setFundraiserTitle(title);
    }
  }, []);

  const handleViewCampaign = () => {
    if (fundraiserId) {
      navigate(`/campaign/${fundraiserId}`);
    } else {
      navigate('/');
    }
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoToLogin = () => {
    navigate('/signin');
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      {/* Simple Success Card */}
      <div className="max-w-md w-full bg-white rounded-2xl shadow-2xl overflow-hidden animate-fadeIn">
        {/* Success Header */}
        <div className="bg-gradient-to-r from-emerald-500 to-teal-600 p-6 text-center">
          <div className="w-20 h-20 mx-auto bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center border-2 border-white/50 mb-3">
            <CheckCircle className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-1">
            Fundraiser Created!
          </h1>
          <p className="text-emerald-100 text-sm">
            Your fundraiser has been successfully published
          </p>
        </div>

        {/* Success Body */}
        <div className="p-6">
          {/* Fundraiser ID */}
          
          {/* Success Message */}
          <div className="text-center mb-6">
            <p className="text-gray-600 text-sm">
              Your fundraiser is now live and ready to accept donations. 
              Share it with your network to start raising funds.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-3">
       

            <div className="grid grid-cols-2 gap-3">
              <button
                onClick={handleGoHome}
                className="py-3 bg-white border-2 border-gray-200 text-gray-700 rounded-xl font-medium text-sm hover:bg-gray-50 hover:border-gray-300 transition-all duration-300 flex items-center justify-center gap-2"
              >
                <Home className="w-4 h-4" />
                <span>Home</span>
              </button>

              {/* <button
                onClick={handleGoToLogin}
                className="py-3 bg-white border-2 border-teal-200 text-teal-700 rounded-xl font-medium text-sm hover:bg-teal-50 hover:border-teal-300 transition-all duration-300 flex items-center justify-center gap-2"
              >
                <LogIn className="w-4 h-4" />
                <span>Login</span>
              </button> */}
            </div>
          </div>

          {/* Footer Note */}
          <p className="text-xs text-gray-400 text-center mt-6">
            You can now login to manage your fundraiser and track donations
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.4s ease-out;
        }
      `}</style>
    </div>
  );
};

export default FundraiserSubmissionSuccess;